import { CheckCircle2, Circle, Loader2, XCircle } from 'lucide-react';
import type { AgentTask } from '../../lib/api';

interface TaskTimelineProps {
  tasks: AgentTask[];
  activeTaskId?: string | null;
}

function statusIcon(status: string) {
  switch (status) {
    case 'completed':
      return <CheckCircle2 size={14} className="text-emerald-400" />;
    case 'failed':
    case 'cancelled':
      return <XCircle size={14} className="text-zt-danger" />;
    case 'running':
    case 'planning':
      return <Loader2 size={14} className="animate-spin text-zt-primary" />;
    default:
      return <Circle size={14} className="text-zt-muted" />;
  }
}

export default function TaskTimeline({ tasks, activeTaskId }: TaskTimelineProps) {
  if (tasks.length === 0) {
    return (
      <div className="rounded-lg border border-zt-border bg-zt-surface p-4 text-sm text-zt-muted">
        No agent tasks yet. Enable agent mode and send a goal to start.
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <h3 className="text-sm font-medium text-white">Agent tasks</h3>
      <ul className="space-y-2">
        {tasks.map((task) => (
          <li
            key={task.id}
            className={`rounded-lg border px-3 py-2 text-sm ${
              task.id === activeTaskId
                ? 'border-zt-primary/50 bg-zt-primary/5'
                : 'border-zt-border bg-zt-surface'
            }`}
          >
            <div className="flex items-center gap-2">
              {statusIcon(task.status)}
              <span className="font-medium text-slate-200">{task.type}</span>
              <span className="ml-auto text-xs capitalize text-zt-muted">{task.status}</span>
            </div>
            {task.goal && <p className="mt-1 truncate text-xs text-zt-muted">{task.goal}</p>}
            {task.pendingQuestion && (
              <p className="mt-1 text-xs text-amber-300">Needs input: {task.pendingQuestion}</p>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
